export var AttendantStatus;
(function (AttendantStatus) {
    AttendantStatus["ONLINE"] = "Online";
    AttendantStatus["PAUSE"] = "Pause";
    AttendantStatus["INVISIBLE"] = "Invisible";
    AttendantStatus["OFFLINE"] = "Offline";
})(AttendantStatus || (AttendantStatus = {}));
